import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'
import { setupHashScroll, teardownHashScroll } from '../hash_scroll'

export default class extends Controller {
  static targets = ['overlay', 'expertTooltip']

  initialize () {
    this.scroll = new SmoothScroll(null, {
      offset: 55,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
  }

  connect () {
    this.overlayTargets.forEach((target) => {
      target.classList.add('viewcomponent::site::pages::facility::summary::desktop::visible')
    })

    setupHashScroll(this)
  }

  disconnect () {
    teardownHashScroll(this)
  }

  get className () {
    return this.element.dataset.classname
  }

  hide (e) {
    e.target.classList.remove('viewcomponent::site::pages::facility::summary::desktop::visible')
  }

  scrollToElement (e) {
    const link = e.target.closest('a')
    if (link && link.hash) {
      const element = document.querySelector(link.hash)
      if (element) {
        e.preventDefault()
        this.scroll.animateScroll(element)
      }
    }
  }

  toggle () {
    if (this.expertTooltipTargets[0].classList.contains(`${this.className}::accordion-close`)) {
      this.open()
    } else {
      this.close()
    }
  }

  open () {
    this.expertTooltipTargets.forEach((target) => {
      target.classList.remove(`${this.className}::accordion-close`)
      target.classList.add(`${this.className}::accordion-open`)
    })
  }

  close () {
    this.expertTooltipTargets.forEach((target) => {
      target.classList.remove(`${this.className}::accordion-open`)
      target.classList.add(`${this.className}::accordion-close`)
    })
  }
}
